<template>
    <div class="left-section">
        <div class="logo-img">
            <img src="/img/id/idconnect.png" alt="ID Connect">
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped lang="scss">


.left-section {
	background-image: url('/img/ptsi_login_bg.jpg');
	background-repeat: no-repeat;
  	background-size: cover;
	padding: 16px 20px;
	height: 100vh;
}
.left-section .logo-img {
	display: flex;
	align-items: center;
	margin: 12px 0 0 24px;
}
.left-section .logo-img img{
	width: 240px;
	height: auto;
	filter: brightness(0) invert(1);
}

</style>
